import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles, CardContent, CardActions, Card } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    popbutton: {
        fontSize: '16px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
        // autofocus: 'none !important',
    },
    button1: {
        marginRight: '25px',
    },
    cardContent: {
        paddingLeft: '24px',
        paddingTop: '10px',
    },
    cardAction: {
        marginLeft: '14px',
        paddingBottom: '20px',
        paddingTop: '15px',
    },
    scrollHeight: {
        height: '100px',
        overflowY: 'scroll',
    },
    fontFamily: {
        fontFamily: 'Rubik',
        '& .MuiTypography-h6': {
            fontFamily: 'Rubik'
        }
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function SubmitButtonWarningPopUp(props) {
    const classes = useStyles();
    const [open, setOpen] = useState(props.showSubmitButtonWarning);
    const stageID = useSelector((state) => state.serviceCheckListReducer.selectedStageId);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        props.handleCloseSubmitButtonErrorPopUP();
    };

    return (
        <div className={classes.root}>
            <Card>
                <CardContent className={classes.cardContent}>
                    <Dialog
                        open={open}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogTitle id="alert-dialog-title" style={{ padding: '16px 24px 0px 24px' }} className={classes.fontFamily}>Warning</DialogTitle>
                        <DialogContent className={classes.scrollHeight}>
                            <DialogContentText id="alert-dialog-slide-description" className={classes.fontFamily} style={{ marginBottom: '0px' }}>
                                {stageID === 3 || stageID === 4 || stageID === 7 || stageID === 8 ?
                                    <span>Following rows contain some data which are pending for relevance categorisation. Please check the relevance before submitting.</span>
                                    : null}
                                {stageID === 5 ?
                                    <span>Following rows contain some data which are partially relevant or irrelevant. Hence, you wont be able to submit L1 checklist. Generate L2 checklist for client to make the necessary updates.</span>
                                    : null}
                                {/* Irrelevent Field According ---- */}
                                {props.irrevelentFieldAccording.map((According, index) => {
                                    return (
                                        <li key={index}>
                                            {According}
                                        </li>
                                    );
                                })}
                            </DialogContentText>
                            {/* <Alert severity="warning"> */}
                            {/* <Alert>
                        <AlertTitle>Warning</AlertTitle>
                        Irrelevent Field According ----
                        {props.irrevelentFieldAccording.map((According, index) => {
                            return (
                                <li key={index}>
                                    {According} —<strong>check it out!</strong>
                                </li>
                            );
                        })}
                    </Alert> */}
                        </DialogContent>
                        <CardActions className={classes.cardAction}>
                            {/* <DialogActions> */}
                            <div>
                                <Button onClick={handleClose} color="primary" className={classes.popbutton}>
                                    Ok
                                </Button>
                            </div>
                            {/* </DialogActions> */}
                        </CardActions>
                    </Dialog>
                </CardContent>
            </Card>
        </div>
    );
}
